module.exports = __webpack_public_path__ + "fonts/SofiaProMedium-Italic.c9882a1a.ttf";